import React, {Component, useState, useEffect} from 'react'
import {Redirect, Link} from 'react-router-dom';
import UserService from "../../API/user/UserService"
import {Card, Input, Button} from 'antd'
import PropTypes from 'prop-types';

import "./Login.css"

import Navbar from '../../components/layout/Navbar';
import Footer3 from '../../components/layout/Footer3';

const ResetPasswordInner = (props) => {
    const [toast, setToast] = useState(null);

    useEffect(() => {
        if (!toast) return;
        const timer = setTimeout(() => setToast(null), 5000);
        return () => clearTimeout(timer);
    }, [toast]);

    return (
        <>
            <Navbar />
            <ResetPassword {...props} setToast={setToast} />
            {toast && (
                <div className="toast-notification-wrapper">
                    <div className={`toast-notification ${toast.type || 'error'}`}>
                        <div>
                            {toast.title && (
                                <div className="toast-notification-title">{toast.title}</div>
                            )}
                            <div>{toast.message}</div>
                        </div>
                        <button
                            type="button"
                            className="toast-notification-close"
                            onClick={() => setToast(null)}
                        >
                            ×
                        </button>
                    </div>
                </div>
            )}
            <Footer3 />
        </>
    );
};

class ResetPassword extends Component {
    constructor(props) {
        super(props)

        this.state = {
            email: '',
            isLoading: false,
            feedback: null,
            redirect: false,
        }
    }


    static contextTypes = {
        encrypt: PropTypes.func.isRequired,
        decrypt: PropTypes.func.isRequired,
    }

    submit = () => {
        this.setState({isLoading: true})
        if (this.state.email === '') {
            const msg = "Please enter your email address.";
            this.setState({isLoading: false, feedback: msg})
            this.props.setToast && this.props.setToast({
                type: 'error',
                title: 'Missing information',
                message: msg,
            });
        } else {
            UserService.forgotPassword(this.state.email)
                .then((resp) => {
                    const msg = "If this email is registered, we've sent password reset instructions.";
                    this.setState({isLoading: false, feedback: msg})
                    this.props.setToast && this.props.setToast({
                        type: 'success',
                        title: 'Email sent',
                        message: msg,
                    });
                    this.setState({redirect: true})
                })
                .catch((err) => {
                    console.error('Forgot password error:', err?.response?.data || err);
                    const msg = 'We could not send reset instructions. Please try again later.';
                    this.setState({isLoading: false, feedback: msg});
                    this.props.setToast && this.props.setToast({
                        type: 'error',
                        title: 'Reset failed',
                        message: msg,
                    });
                });
        }
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }


    render() {
        if (this.state.redirect) {
            return <Redirect to={{
                pathname: `/resetotp`,
                state: {email: this.state.email}
            }}
            />
        }
        return (
            <div className='auth-page'>
                <div className='auth-card-wrapper'>
                    <Card className='auth-card'>
                        <h1 className='auth-title'>Reset Password</h1>
                        <p className='auth-subtitle'>
                            Enter your email address to recover your account
                        </p>

                        <div className='auth-form-group'>
                            <label className='auth-label'>Email address</label>
                            <Input
                                name="email"
                                onChange={(e) => this.handleChange(e)}
                                className='auth-input'
                                placeholder='Enter your email'
                            />
                        </div>

                        <Button
                            onClick={this.submit}
                            type="primary"
                            className='auth-btn'
                        >
                            {this.state.isLoading ? (
                                <div className="lds-facebook"><div></div><div></div><div></div></div>
                            ) : "Send Reset Instructions"}
                        </Button>

                        {this.state.feedback && (
                            <p className='auth-feedback'>{this.state.feedback}</p>
                        )}

                        <div className='auth-footer'>
                            Remember your password? <Link to="/login">Sign in</Link>
                        </div>

                        <div className='auth-footer' style={{marginTop: '8px'}}>
                            Don't have an account? <Link to="/register">Sign Up</Link>
                        </div>
                    </Card>
                </div>
            </div>
        )
    }
}


export default ResetPasswordInner;
